/** Learner-facing prices. The paywall leads with the monthly Pro line. */
export const PRO_MONTHLY_USD = 4.99;
export const PRO_YEARLY_USD = 29.99;

export const PRO_MONTHLY_PRICE = '$4.99';
export const PRO_YEARLY_PRICE = '$29.99';
export const DRIVING_PASS_PRICE = '$9.99';

export const PRO_PRICE_LINE = `${PRO_MONTHLY_PRICE}/month`;

export const PRO_PLAN_CHOICES = [
  { id: 'monthly' as const, line: `${PRO_MONTHLY_PRICE}/month`, detail: 'Pro, billed each month' },
  { id: 'yearly' as const, line: `${PRO_YEARLY_PRICE}/year`, detail: 'Pro, billed each year' },
  { id: 'driving-pass' as const, line: DRIVING_PASS_PRICE, detail: 'Driving Pass, one payment' },
];

export type ProCheckoutPlan = 'monthly' | 'yearly';

export function isProCheckoutPlan(id: string): id is ProCheckoutPlan {
  return id === 'monthly' || id === 'yearly';
}

/** Dollars saved by yearly Pro versus twelve monthly payments. */
export function proYearlySavings(): string {
  return (PRO_MONTHLY_USD * 12 - PRO_YEARLY_USD).toFixed(2);
}
